import { useSeo } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import CategoryGate from "./components/CategoryGate";
import FeedSection from "./components/FeedSection";
import FeaturedSpot from "./components/FeaturedSpot";
import PeopleOrgStrip from "./components/PeopleOrgStrip";
import ValueBand from "./components/ValueBand";
import Reviews from "./components/Reviews";
import HomeFaq from "./components/HomeFaq";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "导航爆料 - 分类浏览首页",
  description:
    "按热门话题、热点事件、人物动态、机构观察分类整理的内容浏览站点，提供搜索、热榜与深度复盘。",
  inLanguage: "zh-CN",
  url: "https://daohangbaoliao.example.com/",
  isPartOf: { "@type": "WebSite", name: "导航爆料" },
};

export default function Home() {
  useSeo({
    title: "导航爆料 - 话题事件人物机构分类浏览指南",
    description:
      "导航爆料提供话题、事件、人物与机构的分类整理浏览。快速找到你关心的瓜，按主题归类，吃瓜高效不迷路，浏览更高效。",
    keywords: "导航爆料,热门话题,热点事件,人物动态,机构观察,分类浏览",
    path: "/",
    jsonLd: JSON.stringify(jsonLd),
  });

  return (
    <>
      <Hero />
      <CategoryGate />
      <FeaturedSpot />
      <FeedSection />
      <PeopleOrgStrip />
      <ValueBand />
      <Reviews />
      <HomeFaq />
    </>
  );
}